var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneFooter = function SvgPhoneFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.011 4.328a8.4 8.4 0 0 0 3.661 3.66l1.222-1.221c.15-.15.373-.2.567-.134a6.3 6.3 0 0 0 1.983.317c.306 0 .556.25.556.556v1.938c0 .306-.25.556-.556.556A9.444 9.444 0 0 1 0 .556C0 .25.25 0 .556 0H2.5c.306 0 .556.25.556.556 0 .694.11 1.36.316 1.983a.56.56 0 0 1-.139.567z"
  })));
};
export default SvgPhoneFooter;